import { ReactComponent as ThumbsDownIcon } from 'assets/images/svg/thumbsDown.svg';
import { ReactComponent as ThumbsUpIcon } from 'assets/images/svg/thumbsUp.svg';
import React from 'react';

import { useMessagesContext } from '../MessagesContext';
import './AgentExecution.scss';

interface AgentMessageFeedbackProps {
  messageId: number;
}

export const AgentMessageFeedback: React.FC<AgentMessageFeedbackProps> = ({ messageId }) => {
  const { messages, submitFeedback } = useMessagesContext();

  const message = messages.find((msg) => msg.id === messageId);
  const feedback = message?.feedback;

  const isSubmitting = feedback?.status === 'submitting';
  const hasSubmitted = feedback?.status === 'success';

  const handleFeedback = async (value: 'positive' | 'negative') => {
    if (isSubmitting || hasSubmitted) return;
    await submitFeedback(messageId, value);
  };

  return (
    <div className='message-bubble-feedback-widget'>
      <span className='feedback-text'>
        {hasSubmitted ? 'Thanks for your feedback!' : 'Was this helpful?'}
      </span>

      <button
        data-testid='thumbs-up-btn'
        onClick={() => handleFeedback('positive')}
        disabled={isSubmitting || (hasSubmitted && feedback?.value !== 'positive')}
        className={`feedback-button thumbs-icon ${feedback?.value === 'positive' ? 'selected' : ''} 
          ${hasSubmitted && feedback?.value !== 'positive' ? 'hidden' : ''}
          ${isSubmitting && feedback?.value !== 'positive' ? 'submitting' : ''}`}
      >
        <ThumbsUpIcon />
      </button>

      <button
        data-testid='thumbs-down-btn'
        onClick={() => handleFeedback('negative')}
        disabled={isSubmitting || (hasSubmitted && feedback?.value !== 'negative')}
        className={`feedback-button thumbs-icon ${feedback?.value === 'negative' ? 'selected' : ''}
          ${hasSubmitted && feedback?.value !== 'negative' ? 'hidden' : ''}
          ${isSubmitting && feedback?.value !== 'negative' ? 'submitting' : ''}`}
      >
        <ThumbsDownIcon />
      </button>
      {feedback?.status === 'error' && (
        <span className='feedback-error'>Failed to submit feedback</span>
      )}
    </div>
  );
};
